import { GlobalWorkerOptions } from 'pdfjs-dist';

let workerConfigured = false;

/** Configure PDF.js worker once (CRA serves worker from /public). */
export function ensurePdfJsWorker(): void {
  if (workerConfigured) return;
  const base = process.env.PUBLIC_URL ?? '';
  GlobalWorkerOptions.workerSrc = `${base}/pdf.worker.min.mjs`;
  workerConfigured = true;
}

// Set the worker as soon as this module loads, before any preview calls getDocument.
ensurePdfJsWorker();
